module.exports = __webpack_public_path__ + "static/media/auto-debit-verified.f4cb86c8.svg";